import * as Map from './maps/map.js';

let map;

let mapObj = document.getElementById('franchiseeMap');
let markers = getChildrenOfMapObj(mapObj);
let center = getLatLngCenter(markers);

Map.loader.load().then(() => {
  map = new google.maps.Map(mapObj, {
    center: {
      lat: parseFloat(center[0]),
      lng: parseFloat(center[1])
    },
    zoom: 6,
    styles: Map.stylesMapTypeStyle,
    streetViewControl: false,
    mapTypeControl: false
  });

  const distanceQuery = undefined;

  const icon = {
    url: themeRoot + '/assets/img/pin-inactive.png',
    scaledSize: new google.maps.Size(40, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(0, 0)
  };

  for (let coord of markers) {
    let marker = new google.maps.Marker({
      icon: icon,
      map: map,
      position: {
        lat: parseFloat(coord[0]),
        lng: parseFloat(coord[1]),
      }
    });
  }
});

function rad2degr(rad) { return rad * 180 / Math.PI; }
function degr2rad(degr) { return degr * Math.PI / 180; }

/**
 * @param latLngInDeg array of arrays with latitude and longtitude
 *   pairs in degrees. e.g. [[latitude1, longtitude1], [latitude2
 *   [longtitude2] ...]
 *
 * @return array with the center latitude longtitude pairs in 
 *   degrees.
 */
function getLatLngCenter(latLngInDegr) {
  var LATIDX = 0;
  var LNGIDX = 1;
  var sumX = 0;
  var sumY = 0;
  var sumZ = 0;

  for (var i = 0; i < latLngInDegr.length; i++) {
    var lat = degr2rad(latLngInDegr[i][LATIDX]);
    var lng = degr2rad(latLngInDegr[i][LNGIDX]);
    // sum of cartesian coordinates
    sumX += Math.cos(lat) * Math.cos(lng);
    sumY += Math.cos(lat) * Math.sin(lng);
    sumZ += Math.sin(lat);
  }

  var avgX = sumX / latLngInDegr.length;
  var avgY = sumY / latLngInDegr.length;
  var avgZ = sumZ / latLngInDegr.length;

  // convert average x, y, z coordinate to latitude and longtitude
  var lng = Math.atan2(avgY, avgX);
  var hyp = Math.sqrt(avgX * avgX + avgY * avgY);
  var lat = Math.atan2(avgZ, hyp);

  return ([rad2degr(lat), rad2degr(lng)]);
}

/**
 * @param mapObj - DOM element of map with coordinates as children
 * 
 * @return - Converted array formatted [[lat, lng], [lat, lng]]
 */
function getChildrenOfMapObj(mapObj) {
  if (mapObj && mapObj.children) {
    let formattedCoords = [];

    for (let coordEl of mapObj.children) {
      let lat = coordEl.getAttribute('data-lat');
      let lng = coordEl.getAttribute('data-lng');

      if (lat && lng) {
        formattedCoords.push([lat, lng]);
      }
    }

    return formattedCoords;
  }

  return [];
}